<template>
  <div class="llp-rise p-3">
    <h4>Rise in LLPs and LPs active on the U.K. corporate register</h4>
    <p>Obscure U.K. companies, popular with money launderers, increased fivefold.</p>
    <stacked-column-chart no-direct-labeling :data="data" :social-mode="socialMode" :keys="['llp', 'lp']" :groups="['Limited Liability Partnership', 'Limited Partnership']" :x-axis-tick-format="xAxisFormatter" y-axis-tick-format=",.0f" :fixed-height="height" />
    <p class="text-muted mt-2 small text-right">Companies House, the U.K. corporate registry</p>
  </div>
</template>

<script>
import chart from '../mixins/chart'

export default {
  name: 'FiledSars',
  mixins: [chart],
  data () {
    return {
      data: [
        {
          date: 2004,
          llp: 7396,
          lp: 11270,
          total: 18666
        },
        {
          date: 2005,
          llp: 11942,
          lp: 12390,
          total: 24332
        },
        {
          date: 2006,
          llp: 17620,
          lp: 13448,
          total: 31068
        },
        {
          date: 2007,
          llp: 24825,
          lp: 14430,
          total: 39255
        },
        {
          date: 2008,
          llp: 32499,
          lp: 15634,
          total: 48133
        },
        {
          date: 2009,
          llp: 38956,
          lp: 16789,
          total: 55745
        },
        {
          date: 2010,
          llp: 41386,
          lp: 17893,
          total: 59279
        },
        {
          date: 2011,
          llp: 46034,
          lp: 19438,
          total: 65472
        },
        {
          date: 2012,
          llp: 52438,
          lp: 21720,
          total: 74158
        },
        {
          date: 2013,
          llp: 57100,
          lp: 24489,
          total: 81589
        },
        {
          date: 2014,
          llp: 59710,
          lp: 28515,
          total: 88225
        },
        {
          date: 2015,
          llp: 59743,
          lp: 32021,
          total: 91764
        },
        {
          date: 2016,
          llp: 60209,
          lp: 39601,
          total: 99810
        },
        {
          date: 2017,
          llp: 60778,
          lp: 45250,
          total: 106028
        },
        {
          date: 2018,
          llp: 53848,
          lp: 49287,
          total: 103135
        },
        {
          date: 2019,
          llp: 52429,
          lp: 51761,
          total: 104190
        },
        {
          date: 2020,
          llp: 51154,
          lp: 53273,
          total: 104427
        }
      ]
    }
  },
  methods: {
    xAxisFormatter (d) {
      if (this.$el.offsetWidth < 600) {
        return d % 2 === 0 ? `'${String(d).substring(2, 4)}` : ''
      } else if (this.$el.offsetWidth < 800) {
        return `'${String(d).substring(2, 4)}`
      }
      return d
    }
  }
}
</script>

<style lang="scss">
  .llp-rise {

    .stacked-column-chart__groups__item__bars__item__value {
      font-size: 0.85rem;
    }
  }
</style>
